const data = {
    module_name: "destinatarios",
    title: "Destinatarios",
    key: 'destinatarios',
    category_key: "cliente",
    excel_key: "clients"
}

module.exports = data